var TOASTS_CONTEXT_ERROR_MESSAGES = {
  NO_TOASTS_DISPATCH_CONTEXT: "No ToastsDispatchContext provided",
  NO_TOASTS_STATE_CONTEXT: "No ToastsStateContext provided"
};

export { TOASTS_CONTEXT_ERROR_MESSAGES };
